<template>
  <div class="modal offer-modal skin-modal contact-info-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="@/assets/close.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>{{ currentStepTitle }}</b>
              </div>
              <!-- Step 1: Contact Information -->
              <div class="form-fields-wrapper" v-if="step === 1">
                <label class="input-container">
                  <input type="text" placeholder="Name" v-model="name" />
                </label>
                <label class="input-container">
                  <input type="text" placeholder="Surname" v-model="surname" />
                </label>
                <label class="input-container">
                  <input type="email" placeholder="E-mail address" v-model="email" />
                </label>
                <label class="input-container">
                  <input type="tel" placeholder="Phone" v-model="phone" />
                </label>
                <label class="input-container">
                  <select v-model="country">
                    <option disabled selected value="">{{ $t('Country') }}</option>
                    <option v-for="(item, i) in countryOptions" :value="item" :key="i">
                      {{ item.title }}
                    </option>
                  </select>
                </label>
                <label class="input-container">
                  <input type="text" placeholder="City" v-model="city" />
                </label>
                <label class="input-container">
                  <input type="text" placeholder="Address" v-model="address" />
                </label>
                <label class="input-container">
                  <input type="text" placeholder="Post Code" v-model="postCode" />
                </label>
              </div>
              <!-- Step 2: Payment Method Selection -->
              <div class="form-fields-wrapper" v-if="step === 2 && !paymentMethodSelected">
                <div class="payment-method-selection">
                  <button v-if="$parent.payoutMethods && $parent.payoutMethods.card" @click="selectPaymentMethod('card')" class="button">Credit/Debit card</button>
                  <button v-if="$parent.payoutMethods && $parent.payoutMethods.sepa" @click="selectPaymentMethod('sepa')" class="button">SEPA</button>
                </div>
              </div>
              <!-- Step 3a: Card Payment Details -->
              <div class="form-fields-wrapper" v-if="step === 2 && paymentMethodSelected && withdrawMethod === 'card'">
                <div class="cta-container" v-if="termsAndConditionsUrl && privacyPolicyUrl">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">{{ $t('I agree with') }} </span>
                        <router-link v-if="privacyPolicyUrl" :to="privacyPolicyUrl" class="title">{{ $t('Privacy Policy') }}</router-link>
                        <span class="title"> {{ $t('and') }} </span>
                        <router-link v-if="termsAndConditionsUrl" :to="termsAndConditionsUrl" class="title">{{ $t('Terms and conditions') }}</router-link>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Step 3b: SEPA Payment Details -->
              <div class="form-fields-wrapper" v-if="step === 2 && paymentMethodSelected && withdrawMethod === 'sepa'">
                <label class="input-container">
                  <input type="text" v-model="bank_holder_name" placeholder="First Name" />
                </label>
                <label class="input-container">
                  <input type="text" v-model="bank_holder_surname" placeholder="Last Name" />
                </label>
                <label class="input-container">
                  <input type="text" maxlength="34" v-model="iban_number" placeholder="IBAN" @input="formatIban" />
                </label>
                <div class="cta-container" v-if="termsAndConditionsUrl && privacyPolicyUrl">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">I agree with </span>
                        <router-link v-if="privacyPolicyUrl" :to="privacyPolicyUrl" class="title"
                          >Privacy Policy
                        </router-link>
                        <span class="title"> and </span>
                        <router-link v-if="termsAndConditionsUrl" :to="termsAndConditionsUrl" class="title"
                          >Terms and Conditions</router-link
                        >
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <!--Error message -->
              <transition name="slide">
                <div v-if="localError" class="error-desc desc red">
                  {{ localError }}
                </div>
              </transition>

              <!-- Navigation buttons -->
              <div class="buttons buttons-special">
                <!-- Step 1 buttons -->
                <button v-if="step === 1" class="button orange-btn" @click="close">
                  <span>Back</span>
                </button>
                <button v-if="step === 1" class="button" @click="goToStep2">
                  <span>Next</span>
                </button>
                <!-- Step 2 buttons - before payment method selection -->
                <button v-if="step === 2 && !paymentMethodSelected" class="button orange-btn" @click="goToStep1">
                  <span>Back</span>
                </button>
                <!-- Step 2 buttons - after payment method selection -->
                <button
                  v-if="step === 2 && paymentMethodSelected"
                  class="button orange-btn"
                  @click="resetPaymentMethod"
                >
                  <span>Back</span>
                </button>
                <button v-if="step === 2 && paymentMethodSelected" class="button" @click="confirm">
                  <span>Submit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'

  export default {
    name: 'AcceptOfferModal',
    props: [],
    components: {},
    data() {
      return {
        step: 1,
        localError: null,
        paymentMethodSelected: false,
        card_holder_name: '',
        card_number: '',
        expire_month: '',
        expire_year: '',
        email: '',
        name: '',
        surname: '',
        phone: '',
        country: '',
        city: '',
        address: '',
        postCode: '',
        terms: false,
        countryOptions: [],
        withdrawMethod: 'card',
        iban_number: '',
        bank_holder_name: '',
        bank_holder_surname: ''
      }
    },
    mounted() {
      this.getCounties()
      this.fetchUserProfile()
    },
    computed: {
      ...mapGetters('staticPages', ['getTermsPage', 'getPrivacyPage']),
      // ...mapState('offers', ['error']),
      ...mapState('offers', ['orderToView']),
      ...mapState('app', ['currency']),
      currentStepTitle() {
        if (this.step === 1) {
          return 'CONTACT INFORMATION'
        } else if (this.step === 2 && !this.paymentMethodSelected) {
          return 'PAYMENT METHOD'
        } else if (this.step === 2 && this.paymentMethodSelected) {
          return 'PAYMENT DETAILS'
        }
        return ''
      },
      privacyPolicyUrl() {
        const privacyPage = this.getPrivacyPage
        return privacyPage ? { name: 'TextPage', params: { slug: privacyPage.slug } } : null
      },
      termsAndConditionsUrl() {
        const termsPage = this.getTermsPage
        return termsPage ? { name: 'TextPage', params: { slug: termsPage.slug } } : null
      }
    },
    methods: {
      ...mapActions('offers', ['requestPayout']),
      ...mapActions('modals', ['openSignInModal', 'closeAcceptOfferModal']),

      clearLocalError() {
        this.localError = null
      },

      selectPaymentMethod(method) {
        this.clearLocalError() // Clear error on action
        this.withdrawMethod = method
        this.paymentMethodSelected = true
        this.clearPaymentFields()
      },
      resetPaymentMethod() {
        this.clearLocalError() // Clear error on action
        this.paymentMethodSelected = false
        this.terms = false
        this.clearPaymentFields()
      },
      clearPaymentFields() {
        this.card_number = ''
        this.card_holder_name = ''
        this.expire_month = ''
        this.expire_year = ''
        this.iban_number = ''
        this.bank_holder_name = ''
        this.bank_holder_surname = ''
      },
      goToStep1() {
        this.step = 1
        this.clearLocalError()
      },
      goToStep2() {
        this.clearLocalError()
        const isStep1Valid =
          this.name &&
          this.surname &&
          this.email &&
          this.phone &&
          this.country &&
          this.city &&
          this.address &&
          this.postCode
        if (!isStep1Valid) {
          this.localError = 'Please fill in all contact information fields.'
          return
        }
        this.step = 2
      },
      formatCardNumber() {
        this.clearLocalError()
        this.card_number = this.card_number.replace(/[^0-9]/g, '')
      },
      formatIban() {
        this.clearLocalError()
        this.iban_number = this.iban_number.replace(/[^A-Za-z0-9]/g, '').toUpperCase()
      },
      handleMonthInput() {
        this.clearLocalError()
        this.expire_month = this.expire_month.replace(/[^0-9]/g, '').slice(0, 2)
        if (this.expire_month.length === 1 && parseInt(this.expire_month) > 1) {
          this.expire_month = '0' + this.expire_month
        }
        if (this.expire_month.length === 2) {
          const month = parseInt(this.expire_month)
          if (month < 1 || month > 12) {
            this.expire_month = month > 12 ? '12' : '01'
          }
          this.$nextTick(() => {
            this.$refs.expireYearInput?.focus()
          })
        }
      },
      handleYearInput() {
        this.clearLocalError()
        this.expire_year = this.expire_year.replace(/[^0-9]/g, '').slice(0, 2)
      },
      handleMonthKeydown(event) {
        if (event.key === 'Backspace' && this.expire_month === '') {
          event.preventDefault()
        }
      },
      handleYearKeydown(event) {
        if (event.key === 'Backspace' && this.expire_year === '') {
          event.preventDefault()
          this.$refs.expireMonthInput?.focus()
        }
      },
      isValidExpirationDate() {
        if (!this.expire_month || !this.expire_year) return false
        const month = parseInt(this.expire_month)
        const year = parseInt('20' + this.expire_year)
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1
        if (month < 1 || month > 12) return false
        if (year < currentYear) return false
        if (year === currentYear && month < currentMonth) return false
        return true
      },
      isValidIban() {
        if (!this.iban_number || this.iban_number.length < 15) return false
        const iban = this.iban_number.replace(/\s/g, '')
        const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/
        return ibanRegex.test(iban)
      },
      close() {
        this.closeAcceptOfferModal()
        this.resetModalState()
      },
      resetModalState() {
        this.step = 1
        this.paymentMethodSelected = false
        this.withdrawMethod = 'card'
        this.terms = false
        this.clearPaymentFields()
        this.clearLocalError()
      },
      async confirm() {
        this.clearLocalError()

        if (!this.terms) {
          this.localError = 'You must agree to the Terms and Conditions and Privacy Policy.'
          return
        }

        if (this.withdrawMethod === 'sepa') {
          if (!this.bank_holder_name || !this.bank_holder_surname || !this.iban_number) {
            this.localError = 'Please fill in all bank detail fields.'
            return
          }
          if (!this.isValidIban()) {
            this.localError = 'The IBAN you entered is not valid.'
            return
          }
        }

        let data = {
          id: this.orderToView.id,
          name: this.name,
          surname: this.surname,
          email: this.email,
          phone: this.phone,
          country: this.country.title,
          city: this.city,
          address: this.address,
          postCode: this.postCode,
          currency: this.currency
        }
        if (this.withdrawMethod === 'sepa') {
          data = {
            ...data,
            account_number: this.iban_number,
            first_name: this.bank_holder_name,
            last_name: this.bank_holder_surname
          }
        }

        // Call the action and handle the result locally
        const result = await this.requestPayout({ data, withdrawMethod: this.withdrawMethod })

        if (!result.success) {
          // If the API call fails, set the local error from the response
          this.localError = result.error || 'An unexpected error occurred.'
        }
      },
      async getCounties() {
        try {
          const res = await this.$http.get(process.env.VUE_APP_API + 'countries')
          this.countryOptions = res.data.payload
          if (this.country && typeof this.country === 'object') {
            const foundCountry = this.countryOptions.find((opt) => opt.title === this.country.title)
            if (foundCountry) {
              this.country = foundCountry
            }
          }
        } catch (res) {
          if (res.response?.status === 401) {
            this.openSignInModal()
          }
        }
      },
      async fetchUserProfile() {
        try {
          const res = await this.$http.get(process.env.VUE_APP_API + 'user/profile')
          const { email, name, surname, phone, city, address, post_code, country } = res.data
          this.email = email
          this.name = name
          this.surname = surname
          this.phone = phone
          this.city = city || ''
          this.address = address || ''
          this.postCode = post_code || ''
          if (country) {
            if (this.countryOptions.length > 0) {
              this.country = this.countryOptions.find((opt) => opt.title === country) || ''
            } else {
              this.country = { title: country, value: country }
            }
          }
        } catch (res) {
          if (res.response?.status === 401) {
            this.openSignInModal()
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .payment-method-selection {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .expiration-container {
    position: relative;
    .expiration-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .expiration-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: inherit;
      text-align: center;
      &::placeholder {
        color: #999;
      }
    }
    .expiration-separator {
      margin: 0 8px;
      color: #666;
      font-weight: 500;
    }
  }
  .error-desc {
    margin-top: 10px;
    font-size: 14px;
    &.red {
      color: #e74c3c;
    }
  }
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s ease;
  }
  .slide-enter-from,
  .slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
</style>
